<template>
  <div class="foot">
    <el-button type="primary" @click="tosave">{{title}}</el-button>
    <div class="goottitle">{{foottitle}}</div>
  </div>
</template>

<script>
/*
title按钮名称
foottitle:下方的保存按钮提示
sumnittype：0  1  String  是否修改  修改  0添加
*/
export default {
  props: {
    title: {
      type: String,
      default: '保存'
    },
    foottitle: {
      type: String,
      default: '* 提示：点击审批可设置或修改审批人'
    },
    sumnittype: {
      type: String,
      default: '0'
    }
  },
  methods: {
    tosave () {
      this.$emit('save', this.sumnittype)
    }
  }
}
</script>

<style scoped>
.foot{
  position: absolute;
  left: 0;
  bottom:0px;
  right: 0;
  background-color: #fff;
}
.goottitle {
  margin-top: 10px;
  color: #D35E5E;
}

</style>
